var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(-533 -421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 20,
    height: 20,
    transform: "translate(533 421)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(536.809 425.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M7.241,1.346,1.5,4.257V5.772H13.39V4.249ZM12.6,4.937H2.293V4.782l4.96-2.515L12.6,4.79Z",
    transform: "translate(-1.5 -1.346)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M4.5,38.25H14.721v.835H4.5Z",
    transform: "translate(-3.665 -28.656)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1.5,43.5H13.39v.835H1.5Z",
    transform: "translate(-1.5 -32.445)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M5.25,20.25h.835v4.174H5.25Z",
    transform: "translate(-4.206 -15.413)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M39.75,20.25h.835v4.174H39.75Z",
    transform: "translate(-29.738 -15.413)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M30.75,20.25h.835v4.174H30.75Z",
    transform: "translate(-23.051 -15.413)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M14.25,20.25h.835v4.174H14.25Z",
    transform: "translate(-10.894 -15.413)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M22.5,20.25h.835v4.174H22.5Z",
    transform: "translate(-16.972 -15.413)",
    fill: "#bcbec0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.c479b05514e3c4181de48d0a90cc4bf6.svg";
export { ForwardRef as ReactComponent };